import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	Button,
} from '@chakra-ui/react'
import { InputText, Form, SelectField } from '../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../helpers';


// components/form/ReactSelectField.jsx
import { useField, useFormikContext } from 'formik';
import Select from 'react-select';
import { FormControl, FormLabel, FormErrorMessage } from '@chakra-ui/react';

const ReactSelectField = ({ name, title, options, isRequired = false }) => {
	const { setFieldValue } = useFormikContext();
	const [field, meta] = useField(name);

	return (
		<FormControl isInvalid={meta.touched && meta.error} isRequired={isRequired} mb="10px">
			<FormLabel htmlFor={name}>{title}</FormLabel>
			<Select
				id={name}
				name={name}
				options={options}
				value={options.find(option => option.value === field.value) || null}
				onChange={(option) => setFieldValue(name, option ? option.value : '')}
				onBlur={field.onBlur}
			/>
			<FormErrorMessage>{meta.error}</FormErrorMessage>
		</FormControl>
	);
};





function Edit({ meCloseEdit, loadList,rs }) {

	const [currencyList, setCurrencyList] = useState([]);
	const [countryList, setCountryList] = useState([]);

	useEffect(() => {
		loadCurrency();
		loadCountries();
	}, []);

	const loadCurrency = async () => {
		const url = `${process.env.REACT_APP_API_URL}/currency/list`;
		const data = await fetchWrapper.get(url);
		setCurrencyList(data);
	};

	const loadCountries = async () => {
		const url = `${process.env.REACT_APP_API_URL}/country/list`;
		const data = await fetchWrapper.get(url);
		// Convert to react-select format
		const formatted = data.rows.map(c => ({ label: c.name, value: c.id }));
		setCountryList(formatted);
	};

	const [formData, setFormData] = useState({
		name: rs.name,
		// currency_id: '',
		country_id: rs.country_id,
		billing_currency_id:rs.billing_currency_id,
		id: rs.id,
	});

	const FormSchema = Yup.object().shape({
		name: Yup.string().required('Required'),
		// currency_id: Yup.string().required('Required'),
		country_id: Yup.string().required('Required'),
		billing_currency_id: Yup.string().required('Required'),
	});

	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {
		const url = `${process.env.REACT_APP_API_URL}/sale_channel/update`;
		await fetchWrapper.post(url, values);
		loadList();
		meCloseEdit();
		toast(`Record has been saved`, { type: "info" });
	};

	return (
		<Form
			enableReinitialize
			validationSchema={FormSchema}
			initialValues={formData}
			onSubmit={onSubmit}
		>
			<Box mb="10px">
				<InputText name="name" title="Name" inputProps={{ isRequired: true }} placeholder="Please Enter Contract Name" />
			</Box>

			<Box mb="10px">
				<SelectField name="billing_currency_id" list={currencyList} title="Currency" isRequired />
			</Box>

			<Box mb="10px">
				<ReactSelectField name="country_id" title="Country" options={countryList} isRequired />
			</Box>

			<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
				mb={4}
				type='submit'
			>
				Add New Sale Contract
			</Button>
		</Form>
	);
}

export default Edit;

